import SuperAdminsPage from './SuperAdminsPage';
export default SuperAdminsPage;